import { useEffect, useState } from 'react'

/**
 * Tracks which anchored section is currently the most relevant one on screen.
 */
export function useScrollSpy(ids: string[], offset = 140): string {
  const [activeId, setActiveId] = useState<string>(ids[0] ?? '')

  useEffect(() => {
    function onScroll() {
      let current = ids[0] ?? ''
      for (const id of ids) {
        const el = document.getElementById(id)
        if (!el) continue
        if (el.getBoundingClientRect().top - offset <= 0) {
          current = id
        }
      }
      const nearBottom =
        window.innerHeight + window.scrollY >= document.body.scrollHeight - 80
      if (nearBottom) current = ids[ids.length - 1] ?? current
      setActiveId(current)
    }

    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
    }
  }, [ids, offset])

  return activeId
}
